module.exports = __webpack_public_path__ + "static/photo_5-7be1139108e6544cee4303d8991fcb2c.jpg";